import { observer } from 'mobx-react-lite'
import TagsCell from 'app/components/tags/TagsCell'
import type { ContactJson } from 'app/types/entities'

/**
 * MobX observer boundary for the contacts table Tags column.
 *
 * ADR-0002 identity map: EntityStore keeps one observable instance per contact id, shared by
 * the table row (list.hits[i]) and the drawer (current). The drawer tag editor interns the new
 * tag list into that instance (ContactStore.mergeTags), but TanStack React Table renders rows
 * from a cached row model and does not re-render on an in-place field change. Reading
 * `contact.tags` inside this observer makes MobX re-render just this cell when the shared
 * instance's tags change, so a tag added in the drawer shows in the table row with no list
 * refetch. This mirrors ContactPipelinesCell, which already observes `contact.pipelines`.
 */
export const ContactTagsCell = observer(function ContactTagsCell({ contact }: { contact: ContactJson }) {
  return <TagsCell tags={contact?.tags} workspaceId={contact?.workspaceId} model="contacts" modelId={contact?.id!} />
})
